import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBebPkw4hxLw_zbxvgWOGAc-ete6inXLLM",
  authDomain: "pharmacy-order-intake.firebaseapp.com",
  projectId: "pharmacy-order-intake",
  storageBucket: "pharmacy-order-intake.firebasestorage.app",
  messagingSenderId: "50736644463",
  appId: "1:50736644463:web:81e2d02771ec54247c289a",
  measurementId: "G-H2W68TMP3S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account', // Forces account selection
});

export default app;
